import { lazy } from "react";

// project imports

import MainLayout from "../layout/MainLayout";
import Loadable from "../components/ui/Loadable";

// page routing
const Home = Loadable(lazy(() => import("../pages/home")));
const Service = Loadable(lazy(() => import("../pages/services")));
const About = Loadable(lazy(() => import("../pages/about")));
const Devis = Loadable(lazy(() => import("../pages/devis")));
const Contact = Loadable(lazy(() => import("../pages/contact")));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: "/",
  element: <MainLayout />,
  children: [
    {
      path: "/",
      element: <Home />,
    },
    {
      path: "accueil",
      element: <Home />,
    },
    {
      path: "services",
      element: <Service />,
    },
    {
      path: "a-propos",
      element: <About />,
    },
    {
      path: "devis",
      element: <Devis />,
    },
    {
      path: "contact",
      element: <Contact />,
    },
  ],
};

export default MainRoutes;
